import { TWebsiteBuilderHideableNodeVisibility, websiteBuilderGenerateDefaultHideableNodeVisibility, websiteBuilderNormalizeHideableNodeVisibility } from "../websiteBuilderHideableNode";
import { TWebsiteBuilderNormalizeTraverse } from "../../schema/normalization/websiteBuilderNormalizeEditor";
import { WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION } from "../../schema/websiteBuilderCurrentSchemaVersion";
import { websiteBuilderGenerateDefaultContent, isWebsiteBuilderContent } from "../section/websiteBuilderContent";
import { TWebsiteBuilderMainSection, websiteBuilderSectionValid } from "../section/websiteBuilderSection";
import { IWebsiteBuilderNodeBase } from "../websiteBuilderNode";

export const WEBSITE_BUILDER_ROOT_ID = "root";

export const WEBSITE_BUILDER_ROOT_CLASS_NAME = "website-builder-root";

export interface IWebsiteBuilderRoot extends IWebsiteBuilderNodeBase {
  id: typeof WEBSITE_BUILDER_ROOT_ID;
  type: typeof WEBSITE_BUILDER_ROOT_ID;
  schemaVersion: number;
  headerVisibility: TWebsiteBuilderHideableNodeVisibility;
  footerVisibility: TWebsiteBuilderHideableNodeVisibility;
  children: TWebsiteBuilderMainSection[];
}

export function websiteBuilderRootValid(node: any): node is IWebsiteBuilderRoot {
  const partialNode: Partial<IWebsiteBuilderRoot> = node;

  return (
    partialNode != null &&
    partialNode.id === "root" &&
    partialNode.type === "root" &&
    partialNode.schemaVersion === WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION
  );
}

export function websiteBuilderGenerateDefaultRoot(): IWebsiteBuilderRoot {
  return {
    id: "root",
    type: "root",
    schemaVersion: WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION,
    headerVisibility: websiteBuilderGenerateDefaultHideableNodeVisibility(),
    footerVisibility: websiteBuilderGenerateDefaultHideableNodeVisibility(),
    children: [
      websiteBuilderGenerateDefaultContent(),
    ],
  };
}

export function websiteBuilderNormalizeValidRoot(
  node: IWebsiteBuilderRoot,
  normalizeTraverse: TWebsiteBuilderNormalizeTraverse,
): IWebsiteBuilderRoot {
  const children = node.children?.filter(child => websiteBuilderSectionValid(child) && isWebsiteBuilderContent(child)) ?? [];
  
  const normalizedRoot: IWebsiteBuilderRoot = {
    id: node.id,
    type: node.type,
    schemaVersion: node.schemaVersion,
    headerVisibility: websiteBuilderNormalizeHideableNodeVisibility(node.headerVisibility),
    footerVisibility: websiteBuilderNormalizeHideableNodeVisibility(node.footerVisibility),
    children: children.map(child => normalizeTraverse(child)),
  };

  return normalizedRoot;
}